import { apiCall, API } from '../../utils/APIFunctions';

export function createFolder(data) {
  return apiCall(`${API}/o/folders`, "post", JSON.stringify(data));
}